import objectByID from './objectByID';
import { HANDLE_NEW_QDD } from '../actions/sync';
import { createSelector } from 'reselect'

const categories = (state = [], action) => {
  switch(action.type) {
    case 'CREATE_CATEGORY':
      var category = Object.assign({id: action.id, updatedAt: (new Date()).getTime()}, action.props);
      return [...state, category];
    case 'UPDATE_CATEGORY':
      var category = objectByID(state, action.id);
      var index = state.indexOf(category);
      return [
        ...state.slice(0, index),
        Object.assign({}, category, action.props, {updatedAt: (new Date()).getTime()}),
        ...state.slice(index+1)
      ];
    case 'DELETE_CATEGORY':
      var category = objectByID(state, action.id);
      var index = state.indexOf(category);
      return [
        ...state.slice(0, index),
        ...state.slice(index+1)
      ];
    case HANDLE_NEW_QDD:
      return action.payload.categories || [];
    default:
      return state;
  }
}

export default categories;

export const getAllCategories = (state) => state.slice()
export const categoryByID = objectByID;

const getCategories = (state) => state;

export const sortedCategories = createSelector(
  [getCategories], (categories) => {
    return categories.slice().sort((a, b) => a.title.toLowerCase()
      .localeCompare(b.title.toLowerCase()))
  }
)
